<!--
  Custom Avatar detail: the full preview / edit workspace (CustomAvatarExperience)
  rendered inside the Studio shell. Effects editing, layouts, drag, background
  and the live conversation all live in the shared experience component.
-->
<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'

import CustomAvatarExperience from '../../components/custom-avatar/CustomAvatarExperience.vue'

import '../../styles/pages/avatars.css'

// Named so the layout's KeepAlive can exclude this page by name
// (volatile detail data must not be served from cache).
defineOptions({ name: 'AvatarDetailPage' })
definePage({ meta: { desktopAvatarFallback: '/avatars/custom' } })

const route = useRoute()
const router = useRouter()
const { t } = useI18n()

const avatarId = computed(() => ('id' in route.params ? String(route.params.id) : ''))
// Older links can point at a distinct render asset while saving by console avatar ID.
const characterId = computed(() => (typeof route.query.characterId === 'string'
  ? route.query.characterId.trim() || avatarId.value
  : avatarId.value))
// `?mode=view` opens the immersive preview dialog; Edit is the default entry.
const initialMode = computed(() => (route.query.mode === 'view' ? 'quick' : 'tune'))
</script>

<template>
  <CustomAvatarExperience
    v-if="avatarId"
    :key="`${avatarId}:${characterId}`"
    :avatar-id="avatarId"
    :character-id="characterId"
    :initial-mode="initialMode"
    :back-label="t('page.custom.detail.back')"
    effects-editable
    @close="router.push('/avatars/custom')"
  />
</template>
